import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailUsuarioKCDto, UserMailService } from '../../../../service/auth/user-mail.service';

@Component({
  selector: 'app-consultar-registro-email',
  templateUrl: './consultar-registro-email.component.html',
  styleUrls: ['./consultar-registro-email.component.css']
})
export class ConsultarRegistroEmailComponent {
  form: FormGroup;
  resultado: EmailUsuarioKCDto = null;
  loading = false;
  removendo = false;
  successMessage = '';
  errorMessage = '';

  get errorType(): string {
    return this.errorMessage === 'Nenhum registro de e-mail encontrado para o username informado.' ? 'warning' : 'error';
  }

  constructor(private formBuilder: FormBuilder, private userMailService: UserMailService) {
    this.form = this.formBuilder.group({
      username: ['', [Validators.required, Validators.maxLength(150)]]
    });
  }

  pesquisar(): void {
    console.log('Pesquisando registro de e-mail pelo username:', this.form.value.username);
    this.successMessage = '';
    this.errorMessage = '';
    this.resultado = null;
    this.form.markAllAsTouched();

    if (this.form.invalid || this.loading) {
      return;
    }

    this.loading = true;
    this.userMailService.buscarPorUsername(this.form.value.username).subscribe(
      resultado => {
        this.loading = false;
        this.resultado = resultado;
      },
      error => {
        this.loading = false;
        this.errorMessage = this.getErrorMessage(error);
      }
    );
  }

  remover(): void {
    if (!this.resultado || this.removendo || !window.confirm('Deseja remover este registro de e-mail?')) {
      return;
    }

    this.successMessage = '';
    this.errorMessage = '';
    this.removendo = true;
    this.userMailService.remover(this.resultado.id).subscribe(
      () => {
        this.removendo = false;
        this.resultado = null;
        this.successMessage = 'Registro de e-mail removido com sucesso.';
      },
      error => {
        this.removendo = false;
        this.errorMessage = this.getErrorMessage(error);
      }
    );
  }

  private getErrorMessage(error: any): string {
    return typeof error === 'string' ? error : 'Não foi possível consultar o registro de e-mail.';
  }
}
